import {Component, input, Input} from "@angular/core";
import {SystemInformationResponse} from "@models";
import {SimConfigurationService} from "@services";

@Component({
	selector: "sim-environment-overlay",
	templateUrl: "./environment-overlay.component.html",
	styleUrl: "./environment-overlay.component.scss",
	standalone: false,
})
export class EnvironmentOverlayComponent {
	protected readonly SimConfigurationService = SimConfigurationService;
	protected readonly window = window;

	public info = input<SystemInformationResponse | null>(null);

	public get color(): string {
		return SimConfigurationService.settings.environmentOverlayColor;
	}
}
